const Vue = window.Vue;

export function renderComponentToHtml(component, props) {
    const vm = new Vue({ render: h => h(component, { props }) }).$mount();
    const wrapper = document.createElement('div');
    wrapper.appendChild(vm.$el);
    const html = wrapper.innerHTML;
    vm.$destroy();
    return html;
}
